import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function CollapsibleSection({ 
  icon, 
  title, 
  subtitle, 
  children, 
  defaultOpen = true,
  className = "" 
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`bg-white rounded-2xl border border-gray-200 overflow-hidden transition-all duration-300 ${className}`}>
      {/* Header — always visible, clickable */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-3 w-full px-4.5 py-4 text-left border-none bg-transparent hover:bg-gray-50/50 transition-colors"
      >
        <span className="text-xl flex-shrink-0">{icon}</span>
        <div className="flex-1 min-w-0">
          <div className="text-[15px] font-bold text-[#1E2A3A] truncate">{title}</div>
          {subtitle && <div className="text-[11px] text-gray-500 mt-0.5 truncate">{subtitle}</div>}
        </div>
        <ChevronDown 
          className={`w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0 ${open ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Collapsible body */}
      <div 
        className={`overflow-hidden transition-[max-height,opacity] duration-400 ease-in-out ${open ? 'max-h-[5000px] opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="border-t border-gray-50">
          {children}
        </div>
      </div>
    </div>
  );
}
